<template>
  <div class="vuw-ph-4 vuw-ph-m-0 vuw-relative">
    <span @click="toggleNavigation"
          class="vuw-award-nav-toggle vuw-bg-support-5 vuw-medium vuw-p-4 vuw-pl-m-5 vuw-pr-m-5 vuw-mb-6 vuw-text-primary-1 hide-for-large">
      {{ selectedCategory.name }} {{ countNumberOfAwards(selectedCategory) }}
      <i class="fal vuw-regular vuw-mt-1 vuw-ml-6" :class="[navigationOpen ? 'fa-chevron-up' : 'fa-chevron-down']"/>
    </span>
    <div class="vuw-card-shadow vuw-p-4 vuw-pt-12 vuw-pt-m-12 vuw-pb-m-9 vuw-p-l-6 vuw-bg-support-5 vuw-award-navigation"
         :class="{'vuw-active': navigationOpen}">
      <close-button-atom v-on:close="toggleNavigation" class="hide-for-large"/>
      <ul class="vuw-no-bullet">
        <li
            class="vuw-mb-6 vuw-mb-m-4"
            v-for="parent in categories"
            :key="parent.name"
            :class="{'vuw-has-child': parent.categories.length}">
          <a @click="onClick(parent)" class="vuw-text-primary-1 vuw-category-parent"
             :class="{'vuw-align-justify-top': parent.categories.length, 'vuw-pointer': !parent.selected || parent.categories.length, 'vuw-bold': parent.selected, 'vuw-open': parent.selected}"
             v-toggle-class-directive="{class: 'vuw-open', sharedClass: 'vuw-category-parent', allow: 'vuw-category', clickOutside: 'off'}">
            <span>
                {{ parent.name }} {{ countNumberOfAwards(parent) }}
            </span>
            <i class="fal fa-chevron-down vuw-mt-1 vuw-ml-1" v-if="parent.categories.length"/>
          </a>
          <ul class="vuw-no-bullet" v-if="parent.categories.length">
            <li class="vuw-mt-3 vuw-mt-m-2" v-for="child in parent.categories" :key="child.name" :class="{'vuw-active': child.selected}">
              <span @click="onClick(child)" :class="{'vuw-pointer': !child.selected}">
                {{ child.name }} {{ countNumberOfAwards(child) }}
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {defineComponent} from "@vue/composition-api";
import ToggleClassDirective from "@/shared/directives/toggle-class-directive";
import {useActions, useMutations, useState} from "vuex-composition-helpers";
import CloseButtonAtom from "@/shared/components/atoms/CloseButtonAtom";

export default defineComponent({
  name: "AwardListComponent",
  components: {
    CloseButtonAtom,
  },
  directives: {
    ToggleClassDirective,
  },
  methods: {
    countNumberOfAwards(category) {
      return category.numberOfAwards ? ` (${category.numberOfAwards})` : "";
    },
  },
  setup: () => {
    const {onClick} = useActions(["onClick"]);
    const {toggleNavigation} = useMutations(["toggleNavigation"]);
    const {selectedCategory, navigationOpen, categories} = useState([
      "selectedCategory",
      "navigationOpen",
      "categories",
    ]);

    return {
      selectedCategory,
      navigationOpen,
      categories,
      toggleNavigation,
      onClick,
    };
  },
});
</script>
